import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'

import {
  selectActualCompanyName,
  selectAllActualProperties,
  selectPartner,
} from 'containers/App/selectors'
import { selectCompanyLoader } from 'containers/PartnerOptions/selectors'

import CenteredLoader from '../lib/CenteredLoader'

class PartnerAccess extends React.Component {
  renderChildren = (props) => (
    <>
      {Array.isArray(this.props.children)
        ? this.props.children.map((children, index) =>
            React.cloneElement(children || <>{children}</>, {
              key: index,
              ...props,
            })
          )
        : React.cloneElement(this.props.children, { ...props })}
    </>
  )

  render() {
    const {
      partner,
      className,
      companyLoader,
      actualCompanyName,
      customReasonsText,
      checkPartnerAccess,
      allActualProperties,
      noPermissionText,
      history,
      redirectPath,
    } = this.props

    if (!partner) return this.renderChildren()

    const { licenses, permissions, integrations, ff } = allActualProperties
    const isAdmin = permissions.admin
    const isCompanyIneligible = !checkPartnerAccess(licenses, permissions, integrations, ff)

    if (!isCompanyIneligible) {
      return this.renderChildren({ isAdmin })
    }

    if (isCompanyIneligible && redirectPath) {
      history.push(redirectPath)
    }

    return (
      <div id="partnerAccess-notProvided" className={className}>
        <div className="tac bp mt">
          <img
            className="empty-box"
            src="/static/webapp/images/partner_access_img.svg"
            style={{ width: 'inherit' }}
          />
          {companyLoader ? (
            <CenteredLoader style={{ marginTop: '100px' }} />
          ) : (
            <>
              <div className="title pc">Access denied</div>
              {noPermissionText ? (
                <span>You do not have the required permissions to access this page</span>
              ) : (
                <>
                  {customReasonsText || (
                    <>
                      <p>{`${actualCompanyName} does not meet one, or more of the following conditions:`}</p>
                      <ul>
                        <li>The company's license has expired.</li>
                        <li>
                          You do not have the required permissions for this page.
                          {` Please contact ${actualCompanyName} to edit your permissions.`}
                        </li>
                        <li>Office 365 integration is not active for the selected company</li>
                      </ul>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    )
  }
}

const render = connect(
  (state) => ({
    partner: selectPartner(state),
    companyLoader: selectCompanyLoader(state),
    actualCompanyName: selectActualCompanyName(state),
    allActualProperties: selectAllActualProperties(state),
  }),
  () => ({})
)(PartnerAccess)

const styledRender = styled(render)`
  ul {
    width: 484px;
    margin: auto;
    padding-left: 34px;
    display: block;
    text-align: left;
    li {
      margin-bottom: 10px;
    }
  }
  .title {
    font-weight: 600;
    font-size: 32px;
    margin-bottom: 20px;
  }
`

export default withRouter(styledRender)
